module.exports = __webpack_public_path__ + "static/Phase2-8be8ef155669d89f7ac5427318d134a3.png";